<template>
  <FunnelContents v-bind="funnelData">
    <template #collectivity-picker>
      <ScPlaceholder name="jss-content" :rendering="rendering" />
    </template>
  </FunnelContents>
</template>

<script>
import * as Cycle from '@aon/cycle'
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'

export default {
  name: 'FunnelContentsSitecore',
  components: {
    FunnelContents: Cycle.FunnelContentsSitecore,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  computed: {
    funnelData() {
      return {
        ...this.fields,
        ...this.renderingWithoutFields
      }
    },
    renderingWithoutFields() {
      // Fields are somehow duplicated in the rendering prop, we'll remove them here
      return { ...this.rendering, fields: {} }
    }
  }
}
</script>
